// extracted by mini-css-extract-plugin
export var chevron = "_33-2";
export var chevronCollapsed = "_33-3";
export var collapsibleHeader = "_33-1";
export var container = "_33-0";